module.exports = __webpack_public_path__ + "img/x5.0d715a85.jpg";